
export const PaginateRight = (props : any) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.765 18.296a.96.96 0 0 0 .717-.293l5.281-5.17c.132-.127.227-.258.286-.392.058-.135.088-.282.088-.443 0-.162-.03-.31-.088-.444a1.242 1.242 0 0 0-.286-.391l-5.28-5.164a.96.96 0 0 0-.718-.293 1.04 1.04 0 0 0-.905.505.993.993 0 0 0-.143.528c0 .283.113.534.337.754l4.636 4.505-4.636 4.504c-.224.22-.337.474-.337.762 0 .19.048.363.143.52.095.156.222.28.381.373.159.093.333.14.524.14z" fill="#33C" fillRule="evenodd"/>
        </svg>
    );
}
